<template>
  <div>
    <Header title="Start with your dreams" />
    <vs-button @click="$router.push({ name: 'dreams' })">
      Create Your First Dream
    </vs-button>
    <DreamsPreview class="mt-10" />
  </div>
</template>
<script>
import DreamsPreview from '../Preview/DreamsPreview'

export default {
  components: {
    DreamsPreview,
  },
  props: {
    current: {
      type: Boolean,
      required: false,
      default: () => false
    }
  }
}
</script>
